import { defineMessages } from 'react-intl';

export const scope = 'app.containers.OpeningActivities';

export default defineMessages({
  pageTitle: {
    id: `${scope}.pageTitle`,
    defaultMessage: 'Version History',
  },
  pageDescription: {
    id: `${scope}.pageDescription`,
    defaultMessage: 'View the history of changes made to this opening',
  },
  title: {
    id: `${scope}.title`,
    defaultMessage: 'Version History',
  },
  tableAriaLabel: {
    id: `${scope}.tableAriaLabel`,
    defaultMessage: 'Opening activity history',
  },
  columnUser: {
    id: `${scope}.columnUser`,
    defaultMessage: 'User',
  },
  columnFieldName: {
    id: `${scope}.columnFieldName`,
    defaultMessage: 'Field Name',
  },
  columnOldValue: {
    id: `${scope}.columnOldValue`,
    defaultMessage: 'Old Value',
  },
  columnNewValue: {
    id: `${scope}.columnNewValue`,
    defaultMessage: 'New Value',
  },
  columnTimestamp: {
    id: `${scope}.columnTimestamp`,
    defaultMessage: 'Date and Time',
  },
  loading: {
    id: `${scope}.loading`,
    defaultMessage: 'Loading...',
  },
  noActivities: {
    id: `${scope}.noActivities`,
    defaultMessage: 'No activities found',
  },
  errorLoadingActivities: {
    id: `${scope}.errorLoadingActivities`,
    defaultMessage: 'Error loading activities. Please try again.',
  },
});
